import { blue } from "@mui/material/colors";
import green from "@mui/material/colors/green";
import purple from "@mui/material/colors/purple";
import createTheme from "@mui/material/styles/createTheme";

const { palette } = createTheme();

export const theme = {
  palette: {
    primary: {
      main: blue[500],      
    },
    secondary: {
      main: green[500],
    },  
  },
};